export default "__VITE_ASSET__84729e66__"